import React, { useState } from "react";
import { motion } from "framer-motion";
import InstagramReelPreview from "./previewComponents/InstagramReelPreview";
import InstagramPostPreview from "./previewComponents/InstagramPostPreview";
import FacebookPostPreview from "./previewComponents/FacebookPostPreview";
import YouTubePostPreview from "./previewComponents/YoutubePostPreview";
import { EVENT_OPTIONS } from "./SocialHubBoostEngagement";

const SocialMediaPreview = ({ selectedEvent, title }) => {
  const [selectedPlatform, setSelectedPlatform] = useState("instagram");
  const [selectedOption, setSelectedOption] = useState("Reel");

  const isIntroductionEvent = selectedEvent === EVENT_OPTIONS[0];

  const SOCIAL_MEDIA_PLATFORMS = [
    {
      id: 1,
      name: "Instagram",
      value: "instagram",
    },
    {
      id: 2,
      name: "Facebook",
      value: "facebook",
    },
    ...(!isIntroductionEvent
      ? [
          {
            id: 3,
            name: "YouTube",
            value: "youtube",
          },
        ]
      : []),
  ];

  const platformOptions = {
    instagram: ["Reel", ...(isIntroductionEvent ? [] : ["Post"])],
    facebook: ["Reel", ...(isIntroductionEvent ? [] : ["Post"])],
    ...(isIntroductionEvent ? {} : { youtube: ["Post"] }),
  };

  const handlePlatformChange = (newPlatform) => {
    setSelectedPlatform(newPlatform);
    setSelectedOption(platformOptions[newPlatform][0]);
  };

  return (
    <div className="w-full bg-white">
      <div className="flex relative border-b w-full justify-between items-center">
        {SOCIAL_MEDIA_PLATFORMS.map((platform) => (
          <div
            key={platform.id}
            className={`w-full text-center px-2 py-2 text-[2vh] cursor-pointer relative ${
              selectedPlatform === platform.value
                ? "text-[#144582] font-medium"
                : "text-gray-500"
            }`}
            onClick={() => handlePlatformChange(platform.value)}
          >
            {platform.name}
            {selectedPlatform === platform.value && (
              <motion.div
                layoutId="activePlatform"
                className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#144582]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              />
            )}
          </div>
        ))}
      </div>

      <div className=" flex border border-[#CCCCCC] rounded-lg mt-[8px] justify-between">
        {selectedPlatform &&
          platformOptions[selectedPlatform]?.map((opt) => (
            <motion.button
              key={opt}
              className={`w-full px-6 py-1 rounded-lg text-[2vh] transition-colors ${
                selectedOption === opt
                  ? "bg-[#DF2E2E] text-[white] font-medium"
                  : "bg-gray-100 text-gray-700"
              }`}
              onClick={() => setSelectedOption(opt)}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              {opt}
            </motion.button>
          ))}
      </div>
      <div className="h-[58vh] overflow-hidden mb-[0.5vh]">
        {selectedPlatform === "instagram" && selectedOption === "Reel" && (
          <InstagramReelPreview selectedEvent={selectedEvent} title={title} />
        )}
        {selectedPlatform === "instagram" && selectedOption === "Post" && (
          <InstagramPostPreview selectedEvent={selectedEvent} title={title} />
        )}

        {selectedPlatform === "facebook" && selectedOption === "Reel" && (
          <InstagramReelPreview selectedEvent={selectedEvent} title={title} />
        )}
        {selectedPlatform === "facebook" && selectedOption === "Post" && (
          <FacebookPostPreview selectedEvent={selectedEvent} title={title} />
        )}

        {selectedPlatform === "youtube" && selectedOption === "Post" && (
          <YouTubePostPreview selectedEvent={selectedEvent} title={title} />
        )}
      </div>
    </div>
  );
};

export default SocialMediaPreview;
